import initStatisticAnimation from "../StatisticAnimation/initStatisticAnimation.js";
import { equalHeight } from "../../common/equalHeight.js";

export default function initTabs() {
  const tabEls = document.querySelectorAll(".js-tabs");

  if (tabEls) {
    tabEls.forEach((el, i) => {
      const tabList = el.querySelector('[role="tablist"]');
      const tabs = el.querySelectorAll('[role="tab"]');

      // Add a click event handler to each tab
      tabs.forEach((tab, i) => {
        tab.addEventListener("click", changeTabs);

        i === 0 && tab.click();
      });

      // Enable arrow navigation between tabs in the tab list
      let tabFocus = 0;

      tabList.addEventListener("keydown", (e) => {
        // Move right
        if (e.keyCode === 39 || e.keyCode === 37) {
          tabs[tabFocus].setAttribute("tabindex", -1);
          if (e.keyCode === 39) {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (e.keyCode === 37) {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }

          tabs[tabFocus].setAttribute("tabindex", 0);
          tabs[tabFocus].focus();
        }
      });
    });
  }
}

function changeTabs(e) {
  const target = e.target;
  const parent = target.parentNode;
  const grandparent = parent.parentNode;

  // Remove all current selected tabs
  parent.querySelectorAll('[aria-selected="true"]').forEach((t) => {
    t.classList.remove("tab__btn--active");
    t.setAttribute("aria-selected", false);
  });

  // Set this tab as selected
  target.setAttribute("aria-selected", true);
  target.classList.add("tab__btn--active");

  // Hide all tab panels
  grandparent.querySelectorAll('[role="tabpanel"]').forEach((p) => {
    p.setAttribute("hidden", true);
  });

  // Show the selected panel
  grandparent.parentNode
    .querySelector(`#${target.getAttribute("aria-controls")}`)
    .removeAttribute("hidden");

  const statisticAnimationEls = grandparent.parentNode
    .querySelector(`#${target.getAttribute("aria-controls")}`)
    .querySelectorAll(".js-statistic-animation");

  if (
    document.getElementsByClassName("statistic-animation__description").length
  ) {
    equalHeight(".statistic-animation__description");
  }

  //re run any stat animations when the tab opens
  if (statisticAnimationEls) {
    statisticAnimationEls.forEach((el, j) => {
      initStatisticAnimation(el);
    });
  }
}
